// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.
import collaterals from './issued-loan-collateral.js';

export default [
    {
        path: '/:organisation/loans/issued-loans/repaid',
        component: () =>
            import('@/pages/[organisation]/loans/issued-loans/repaid.vue'),
        name: 'loans.issued-loan.repaid-issued-loans',
        meta: {
            loginRequired: true,
            permission: 'access.finance.loans.issued-loan.update-issued-loan',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/loans/issued-loans/repaid/[id].vue'),
                name: 'loans.issued-loan.view-repaid-issued-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan.update-issued-loan',
                },
            },
        ],
    },

    {
        path: '/:organisation/loans/issued-loans',
        component: () =>
            import('@/pages/[organisation]/loans/issued-loans.vue'),
        name: 'loans.issued-loan.search-issued-loans',
        meta: {
            loginRequired: true,
            permission: 'access.finance.loans.issued-loan.view-issued-loans',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/loans/issued-loans/new.vue'),
                name: 'loans.issued-loan.create-issued-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan.create-issued-loan',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "loans.issued-loan" */ '@/pages/[organisation]/loans/issued-loan/issued-loan/[id].vue'),
                name: 'loans.issued-loan.view-issued-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan.view-issued-loans',
                },
                children: [
                    {
                        path: 'record-payment',
                        component: () =>
                            import(/* webpackChunkName: "loans.issued-loan" */ '@/pages/[organisation]/loans/issued-loan-payment/issued-loan-payment/new.vue'),
                        name: 'loans.issued-loan-payments.create-issued-loan-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.loans.issued-loan-payment.create-issued-loan-payment',
                        },
                    },
                ],
            },
            {
                path: ':id/edit',
                component: () =>
                    import(/* webpackChunkName: "loans.issued-loan" */ '@/pages/[organisation]/loans/issued-loan/issued-loan/[id]/edit.vue'),
                name: 'loans.issued-loan.update-issued-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan.update-issued-loan',
                },
            },
            {
                path: ':id/edit-draft',
                component: () =>
                    import(/* webpackChunkName: "loans.issued-loan" */ '@/pages/[organisation]/loans/issued-loan/draft-issued-loan/[id]/edit.vue'),
                name: 'loans.issued-loan.update-draft-issued-loan',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan.update-issued-loan',
                },
            },
            {
                path: ':id/loan-payments',
                component: () =>
                    import(/* webpackChunkName: "loans.issued-loan" */ '@/pages/[organisation]/loans/issued-loan-payment/issued-loan-payments.vue'),
                name: 'loans.issued-loan-payments.search-issued-loan-payments',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.loans.issued-loan-payment.view-issued-loan-payments',
                },
                children: [
                    {
                        path: ':paymentId/redo-payment',
                        component: () =>
                            import(/* webpackChunkName: "loan.issued-loan" */ '@/pages/[organisation]/loans/issued-loan-payment/redo-issued-loan-payment.vue'),
                        name: 'loans.issued-loan-payments.redo-issued-loan-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.loans.issued-loan-payment.redo-issued-loan-payment',
                        },
                    },
                ],
            },
            ...collaterals,
        ],
    },
];
